import { Text } from '@/components/text';

import type { PropsWithChildren, ReactNode } from 'react';


type PlanDetailItemProps = PropsWithChildren<{
  subHeading?: ReactNode;
  itemType?: 'cart' | 'page';
}>;

const PlanDetailItem = ({
  children,
  subHeading,
  itemType = 'page',
}: PlanDetailItemProps) => {
  if (!children) {
    return null;
  }

  return (
    <div className="flex-1 grow rounded-rad-a border border-gray-200 px-b py-a">
      <Text variant={itemType === 'cart' ? 'mixedH3H4' : 'highlighted'}>
        {children}
      </Text>
      {subHeading}
    </div>
  );
};

export { PlanDetailItem };
